/** @format */

import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { useToast } from 'vue-toastification/composition'
// Notification
// import { useToast } from 'vue-toastification/composition'
// import axios from 'axios'

export default function useInvoicesList(proxy) {
  // Use toast
  // const toast = useToast()
  const toast = useToast()
  const refInvoiceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    'index',
    // {
    //   key: 'id',
    //   label: '#',
    //   thStyle: {
    //     textAlign: 'center',
    //   },
    // },
    {
      key: 'name',
      label: '等级名称',
      formatter: val => `${val}`,
      thStyle: {
        textAlign: 'center',
      },
    },
    {
      key: 'rate',
      label: '佣金百分比',
      thStyle: {
        textAlign: 'center',
      },
    },
    {
      key: 'renew_rate',
      label: '续费百分比',
      thStyle: {
        textAlign: 'center',
      },
    },
    {
      key: 'level_tp',
      label: '等级TP值',
      thStyle: {
        textAlign: 'center',
      },
    },
    {
      key: 'actions',
      label: '操作',
      thStyle: {
        textAlign: 'center',
      },
    },
  ]
  const perPage = ref(100)
  const page_size = ref(10)
  const totalInvoices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refInvoiceListTable.value ? refInvoiceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value,
    }
  })

  const refetchData = () => {
    refInvoiceListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    page_size.value = perPage.value
    refetchData()
  })
  // 查询全部数据
  const fetchInvoices = (ctx, callback) => {
    store
      .dispatch('level-module/fetchInvoices', {
        page_size: page_size.value,
        page: currentPage.value,
        name: searchQuery.value,
      })
      .then(response => {
        const list = response.data
        callback(list)
      })
  }
  // 数据删除
  const confirmDelete = val => {
    store
      .dispatch('level-module/deleteInvoices', val)
      .then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: '删除成功',
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        })
        refetchData()
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: '删除错误!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }
  return {
    fetchInvoices,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refInvoiceListTable,
    statusFilter,
    refetchData,
    confirmDelete,
  }
}
